import { Comment, Text, Fragment, type Slot, type VNode } from 'vue';
import './Array';
import { extend as extendArray } from './Array';
// Force implementation
extendArray();

export function hasSlotContent(
  slot: Slot | undefined | null,
  props: any = {}
): boolean {
  return (! isSlotEmpty(slot, props));
};

export function isSlotEmpty(
  slot: Slot | undefined | null,
  props: any = {}
): boolean {
  return isVNodeEmpty(slot?.(props));
};

export function isVNodeEmpty(
  vnode: VNode | VNode[] | undefined | null
): boolean {
  return (
    (! vnode) ||
    Array.asArray(vnode)?.every(
      (vnode: VNode) =>
        (vnode.type === Comment) ||
        ((vnode.type === Text) && (! vnode.children?.length)) ||
        ((vnode.type === Fragment) && (! vnode.children?.length)),
    )
  );
};
